import jsdk from '../../jsdk';
import t from 'tcomb';
import HTML_Component_Style from './style/HTML_Component_Style';
import { template } from '../../template';

// Rappresenta una componente html
const HTML_Component = t.struct({
  value: t.Str,
  style: HTML_Component_Style
}, 'HTML_Component');

HTML_Component.prototype.to_form = function() {
  var tmpl = template([
    '<div<%= attrs %>>',
      '<%= value %>',
    '</div>'
  ].join(''));

  return tmpl({
    attrs: jsdk.attr({
      style: this.style
    }),
    value: this.value
  });
};

export default HTML_Component;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/HTML_Component.js
 **/